(function () {
  var DESKTOP_MQ = window.matchMedia('(min-width: 990px)');

  function getTabLists() {
    return document.querySelectorAll(
      '.header__inline-menu .mega-menu__list:not(.mega-menu__list--condensed)'
    );
  }

  function activateTab(list, index) {
    var tabs = list.querySelectorAll(':scope > li');
    if (!tabs.length) return;
    var safeIndex = Math.max(0, Math.min(tabs.length - 1, index));
    tabs.forEach(function (tab, i) {
      tab.classList.toggle('evo-mega-tab--active', i === safeIndex);
    });
  }

  function tabIndexFromX(list, clientX) {
    var tabs = list.querySelectorAll(':scope > li');
    var count = tabs.length;
    if (!count) return 0;
    var rect = list.getBoundingClientRect();
    if (!rect.width) return 0;
    var ratio = (clientX - rect.left) / rect.width;
    ratio = Math.max(0, Math.min(0.999999, ratio));
    return Math.floor(ratio * count);
  }

  function setTabMeta(list) {
    var tabs = list.querySelectorAll(':scope > li');
    if (!tabs.length) return;
    list.dataset.evoTabCount = String(tabs.length);
    tabs.forEach(function (tab) {
      tab.style.removeProperty('left');
      tab.style.removeProperty('width');
      tab.style.removeProperty('right');
    });
  }

  function positionMegaPanel(details) {
    if (!DESKTOP_MQ.matches) return;
    var summary = details.querySelector('.details__summary');
    var panel = details.querySelector('.mega-menu__content');
    if (!summary || !panel) return;

    panel.style.removeProperty('left');
    panel.style.removeProperty('transform');
    panel.style.removeProperty('right');

    requestAnimationFrame(function () {
      if (details.getAttribute('open') !== 'true') return;

      var summaryRect = summary.getBoundingClientRect();
      var detailsRect = details.getBoundingClientRect();
      var panelRect = panel.getBoundingClientRect();
      var panelWidth = panelRect.width || panel.offsetWidth || Math.min(720, window.innerWidth - 40);
      var pad = 16;
      var summaryCenter = summaryRect.left + summaryRect.width / 2;
      var panelLeft = summaryCenter - panelWidth / 2;

      if (panelLeft < pad) panelLeft = pad;
      if (panelLeft + panelWidth > window.innerWidth - pad) {
        panelLeft = window.innerWidth - pad - panelWidth;
      }

      var centerRelDetails = panelLeft + panelWidth / 2 - detailsRect.left;
      panel.style.setProperty('left', centerRelDetails + 'px', 'important');
      panel.style.setProperty('right', 'auto', 'important');
      panel.style.setProperty('transform', 'translateX(-50%)', 'important');
    });
  }

  function syncTabUnderSummary(details) {
    var list = details.querySelector('.mega-menu__list:not(.mega-menu__list--condensed)');
    var summary = details.querySelector('.details__summary');
    if (!list || !summary || list.dataset.evoMegaTabsInit !== 'true') return;
    var centerX = summary.getBoundingClientRect().left + summary.getBoundingClientRect().width / 2;
    activateTab(list, tabIndexFromX(list, centerX));
  }

  var TAB_BAR_HEIGHT = 52;

  function isInTabBar(list, clientY) {
    var rect = list.getBoundingClientRect();
    return clientY - rect.top <= TAB_BAR_HEIGHT;
  }

  function pointerActivateTab(event, list) {
    /* Only switch tabs in the top tab bar — not while moving through level-3 links below */
    if (!isInTabBar(list, event.clientY)) return;
    activateTab(list, tabIndexFromX(list, event.clientX));
  }

  function initTabList(list) {
    if (list.dataset.evoMegaTabsInit === 'true') return;
    if (!list.querySelector(':scope > li')) return;

    list.dataset.evoMegaTabsInit = 'true';
    list.dataset.evoMegaTabs = 'true';

    var tabs = list.querySelectorAll(':scope > li');
    setTabMeta(list);
    activateTab(list, 0);

    var panel = list.closest('.mega-menu__content');
    var bindPointer = function (event) {
      pointerActivateTab(event, list);
    };

    list.addEventListener('mousemove', bindPointer);
    list.addEventListener('mouseenter', bindPointer);

    if (panel) {
      panel.addEventListener('mousemove', bindPointer);
      panel.addEventListener('mouseenter', bindPointer);
    }

    tabs.forEach(function (tab, index) {
      var tabLink = tab.querySelector('.mega-menu__link--level-2');
      if (!tabLink) return;
      tabLink.addEventListener('mouseenter', function () {
        activateTab(list, index);
      });
      tabLink.addEventListener('focus', function () {
        activateTab(list, index);
      });
    });
  }

  function initMegaDetails(details) {
    if (details.dataset.evoMegaInit === 'true') return;
    details.dataset.evoMegaInit = 'true';

    details.addEventListener('mouseenter', function () {
      positionMegaPanel(details);
      syncTabUnderSummary(details);
    });

    if (details.getAttribute('open') === 'true') {
      positionMegaPanel(details);
      syncTabUnderSummary(details);
    }

    var observer = new MutationObserver(function () {
      if (details.getAttribute('open') === 'true') {
        positionMegaPanel(details);
        syncTabUnderSummary(details);
      }
    });
    observer.observe(details, { attributes: true, attributeFilter: ['open'] });

    var contentObserver = new MutationObserver(function () {
      if (details.getAttribute('open') === 'true') {
        positionMegaPanel(details);
      }
    });
    var panel = details.querySelector('.mega-menu__content');
    if (panel) {
      contentObserver.observe(panel, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-loaded'] });
    }
  }

  function closeDropdown(details) {
    if (!details) return;
    clearTimeout(details._megaCloseTimer);
    if (typeof details.close === 'function') {
      details.close();
      return;
    }
    details.open = false;
    details.removeAttribute('open');
  }

  function closeSiblingDropdowns(activeDetails) {
    if (!DESKTOP_MQ.matches || !activeDetails) return;
    document.querySelectorAll('.header__inline-menu details.details--dropdown[open], .header__inline-menu details.details--dropdown[open="true"]').forEach(function (details) {
      if (details === activeDetails || details.contains(activeDetails) || activeDetails.contains(details)) return;
      closeDropdown(details);
    });
  }

  function initExclusiveDropdown(details) {
    if (details.dataset.evoExclusiveDropdown === 'true') return;
    details.dataset.evoExclusiveDropdown = 'true';

    details.addEventListener('mouseenter', function () {
      closeSiblingDropdowns(details);
    });
    details.addEventListener('focusin', function () {
      closeSiblingDropdowns(details);
    });
  }

  function initAll() {
    if (!DESKTOP_MQ.matches) return;
    getTabLists().forEach(initTabList);
    document.querySelectorAll('.header__inline-menu details.mega-menu').forEach(initMegaDetails);
    document.querySelectorAll('.header__inline-menu details.details--dropdown').forEach(initExclusiveDropdown);
  }

  function watchLazyMegaContent() {
    var inlineMenu = document.querySelector('.header__inline-menu');
    if (!inlineMenu) return;

    var scheduleInit = (function () {
      var timer;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          initAll();
          document.querySelectorAll('.header__inline-menu details.mega-menu[open="true"]').forEach(function (details) {
            positionMegaPanel(details);
          });
        }, 0);
      };
    })();

    var observer = new MutationObserver(function (mutations) {
      var shouldInit = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-loaded') {
          shouldInit = true;
        }
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (
            node.matches &&
            (node.matches('.mega-menu__list') ||
              node.querySelector('.mega-menu__list') ||
              node.matches('[id^="MegaMenu-Content-"]'))
          ) {
            shouldInit = true;
          }
        });
      });
      if (shouldInit) scheduleInit();
    });

    observer.observe(inlineMenu, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-loaded', 'open'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      watchLazyMegaContent();
    });
  } else {
    initAll();
    watchLazyMegaContent();
  }

  window.addEventListener('resize', function () {
    if (!DESKTOP_MQ.matches) return;
    getTabLists().forEach(setTabMeta);
    document.querySelectorAll('.header__inline-menu details.mega-menu[open="true"]').forEach(function (details) {
      positionMegaPanel(details);
    });
  });

  document.addEventListener('shopify:section:load', initAll);
})();
